<template>
  <div class="card-list-item activity-item">
    <div class="helper-button" v-on:click="openDatePicker"></div>
    <div class="card-item-main-wrap">
      <div class="card-item-main">
        <div class="card-item-image" v-if="itemImage" :style="{ backgroundImage: 'url('+itemImage+')'}"></div>
        <div :class="'card-item-title product-item-title' + (itemImage ? ' has-image' : ' no-image')">
          <div class="card-item-name-wrap"><span class="card-item-name product-item-name">{{ item.text }}</span></div>
          <span v-if="false" class="card-item-price product-item-price"><span v-if="parseInt(product.multiple_prices)">{{ _('From') }} </span>{{ $filters.currency(product.price, product.currency) }}</span>
        </div>
      </div>
    </div>

    <div class="product-item-footer card-item-footer">
      <div class="product-item-footer-row card-item-timerow card-item-footer-row">
        <div class="card-item-time card-item-starttime" v-if="hasMultipleStartTimes">
          <multiselect v-model="selectedStartTime" :options="startTimeValues" :multiple="false" :show-labels="false" :searchable="false" :allow-empty="false" @select="checkSelectedEndTime"></multiselect>
        </div>
        <div class="card-item-time card-item-starttime card-item-starttime-static" v-else>
          <span class="card-static-time card-static-starttime">{{ itemTime }}</span>
        </div>
        <div class="card-item-time card-item-endtime" v-if="hasMultipleEndTimes">
          <multiselect v-model="selectedEndTime" :options="endTimeValues" :multiple="false" :show-labels="false" :searchable="false" :allow-empty="false"></multiselect>
        </div>
        <div class="card-item-time card-item-endtime card-item-endtime-static" v-else>
          <span class="card-static-time card-static-endtime">{{ itemDuration }}</span>
        </div>
      </div>
      <div class="product-item-footer-row card-item-footer-row">
        <div class="input-group product-item-button card-item-button">
          <multiselect v-model="numberOfSeats" v-if="!hasSeatMap" :options="itemRemainingSeatOptions" :show-labels="false" :searchable="false" :allow-empty="false" :multiple="false"	@open="isSelectOpen = true" @close="isSelectOpen = false"></multiselect>
          <span :class="hasSeatMap ? '' : 'input-group-btn'">
            <button ref="addButton" type="button" :class="'btn btn-success'" v-on:click="itemClicked">{{ _('Add') }}</button>
          </span>
        </div>
      </div>
    </div>
  </div>  
</template>
<script>

import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import Multiselect from 'vue-multiselect'

export default {
  data () {
    return {
      numberOfSeats: 1,
      isSelectOpen: false,
      selectedStartTime: false,
      selectedEndTime: false,
      itemDateFormat: 'yyyy-MM-dd HH:mm'
    }
  },
  props: ['item'],
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters(['locale', 'timeFormat', 'timezone']),
    hasSeatMap () {
      return parseInt(this.item.showseatmap)
    },
    itemTime () {
      if (parseInt(this.item.upcoming, 10) !== 1) {
        let endStr = DateTime.fromFormat(this.item.end_date, this.itemDateFormat).toFormat(this.timeFormat)
        if (endStr === '0.00') {
          endStr = '24.00'
        }
        if (endStr === '0:00') {
          endStr = '24:00'
        }
        return DateTime.fromFormat(this.item.start_date, this.itemDateFormat).toFormat(this.timeFormat) + ' - ' + endStr
      }
      return ''
    },
    itemDuration () {
      if (parseInt(this.item.upcoming, 10) !== 1) {
        var dur = DateTime.fromFormat(this.item.end_date, this.itemDateFormat).diff(DateTime.fromFormat(this.item.start_date, this.itemDateFormat), ['hours', 'minutes'])
        let h = Math.floor(parseInt(dur.hours))
        let m = Math.floor(parseInt(dur.minutes))
        return h + ' h ' + m + ' min'
      }
      return ''
    },
    itemReservations () {
      return parseInt(this.item.resource_reservations, 10)
    },
    itemCapacity () {
      return parseInt(this.item.resource_capacity, 10)
    },
    itemScanned () {
      return parseInt(this.item.resource_confirmed, 10)
    },
    itemRemainingSeats () {
      return parseInt(this.item.maxcount, 10)
    },
    itemImage () {
      return this.item.image
    },
    isItemAvailable () {
      return this.itemRemainingSeats > 0
    },
    itemRemainingSeatOptions () {
      let returnValues = []
      for (let i = 0; i < this.itemRemainingSeats; i++) {
        returnValues.push(i+1)
      }
      return returnValues;
    },
    hasMultipleStartTimes () {
      if (this.item && this.item.starttimes && this.item.starttimes.length > 1) {
        return true
      }
      return false
    },
    hasMultipleEndTimes () {
      if (!this.selectedStartTime) {
        return false
      }
      const st = DateTime.fromFormat(this.selectedStartTime, this.timeFormat).toFormat('H.mm')
      if (this.item.endtimes && this.item.endtimes[st] && this.item.endtimes[st].length > 1) {
        return true
      }
      return false
    },
    startTimeValues () {
      let returnValues = [];
      let item = this.item;
      let $this = this
      if (typeof item === 'undefined') {
        return returnValues
      }
      if (this.item && this.item.starttimes) {
        this.item.starttimes.forEach(function(element) {
          returnValues.push(DateTime.fromFormat(element, 'H.mm').toFormat($this.timeFormat))
        })
      }
      return returnValues
    },
    endTimeValues () {
      let returnValues = [];
      let item = this.item;
      let $this = this
      if (typeof item === 'undefined') {
        return returnValues
      }
      if (this.item && this.item.starttimes) {
        const st = DateTime.fromFormat(this.selectedStartTime, this.timeFormat).toFormat('H.mm')
        this.item.endtimes[st].forEach(function(element) {
          returnValues.push(DateTime.fromFormat(element, 'H.mm').toFormat($this.timeFormat))
        })
      }
      return returnValues;
    }
  },
  methods: {
    openDatePicker () {
      this.$emit('openDatePicker')
    },
    checkSelectedEndTime (newStartTime) {
      const nst = DateTime.fromFormat(newStartTime, this.timeFormat).toFormat('H.mm')
      if (!this.item || !this.item.endtimes || !this.item.endtimes[nst]) {
        return
      }
      const se = DateTime.fromFormat(this.selectedEndTime, this.timeFormat).toFormat('H.mm')
      if (!this.item.endtimes[nst].includes(se)) {
        if (this.item.endtimes[nst][0]) {
          const timeValue = this.item.endtimes[nst][0].replace(/\+[0-9]+/, '')
          this.selectedEndTime = DateTime.fromFormat(timeValue, 'H.mm').toFormat(this.timeFormat)
        }
      }
    },
    itemClicked () {
      if(this.isItemAvailable) {
        const item = Object.assign({}, this.item)
        let sdArr = this.item.start_date.split(' ')
        let edArr = this.item.end_date.split(' ')
        if (this.selectedStartTime) {
          item.start_date = sdArr[0] + ' ' + DateTime.fromFormat(this.selectedStartTime, this.timeFormat).toFormat('H:mm')
        }
        if (this.selectedEndTime) {
          item.end_date = edArr[0] + ' ' + DateTime.fromFormat(this.selectedEndTime, this.timeFormat).toFormat('H:mm')
        }
        this.$emit('itemClicked', item, this.numberOfSeats)
        this.reset()
      }
    },
    reset () {
      if (this.item && this.item.starttimes) {
        if (DateTime.fromFormat(this.item.start_date, this.itemDateFormat).startOf('day') <= DateTime.now().startOf('day')) {
          for (let i = 0; i < this.item.starttimes.length; i++) {
            if (DateTime.fromFormat(this.item.starttimes[i], 'H.mm').toUnixInteger() >= DateTime.now().toUnixInteger()) {
              this.selectedStartTime = DateTime.fromFormat(this.item.starttimes[i], 'H.mm').toFormat(this.timeFormat)
              break
            }
          }
        } else {
          this.selectedStartTime = DateTime.fromFormat(this.item.starttimes[0], 'H.mm').toFormat(this.timeFormat)
        }
      }
      if (this.selectedStartTime) {
        const st = DateTime.fromFormat(this.selectedStartTime, this.timeFormat).toFormat('H.mm')
        if (this.item && this.item.endtimes && this.item.endtimes[st] && this.item.endtimes[st][0]) {
          const timeValue = this.item.endtimes[st][0].replace(/\+[0-9]+/, '')
          this.selectedEndTime = DateTime.fromFormat(timeValue, 'H.mm').toFormat(this.timeFormat)
        }
      }
      this.numberOfSeats = 1
      if (this.$refs && this.$refs.addButton) {
        this.$refs.addButton.blur()
      }
    }
  },
  mounted () {
    this.reset()
  },
  updated () {
    if (this.item && this.item.starttimes && this.selectedStartTime && !this.item.starttimes.includes(DateTime.fromFormat(this.selectedStartTime, this.timeFormat).toFormat('H.mm'))) {
      this.reset()
    }
  }
}

</script>